import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {usePageStateSelector} from '../../../../../hooks/state'
import {getTax} from '../../../../../selectors/tax-and-fee'
import {classes} from './tax.st.css'

export interface TaxProps {
  ticket: wix.events.ticketing.TicketDefinition
  className?: string
  overridePrice?: string
}

export const Tax = ({ticket, className, overridePrice}: TaxProps) => {
  const {t} = useTranslation()
  const event = usePageStateSelector(state => state.event)
  const abstract = isDonationTicketDefinition(ticket) && !overridePrice
  const {getFormattedMoney} = useCurrencyFormatter()
  const tax = getTax({event, ticket, t, overridePrice, abstract, getFormattedMoney})

  if (!tax) {
    return null
  }

  return (
    <Text
      tagName="p"
      className={classNames(classes.tax, className)}
      data-hook={DH.TAX_LABEL}
      aria-label={t('mobile.thanks.tax', {tax})}
    >
      {tax}
    </Text>
  )
}
